import * as moment from 'moment';
import axios from 'axios';
import Icon from 'react-icons-kit';
import { FormEvent, useEffect, useState } from 'react';
import { pencil } from 'react-icons-kit/icomoon/pencil';
import { profile } from 'react-icons-kit/icomoon/profile';
import styled from 'styled-components';
import SwapDonorsNav from './swap-donors/nav';

const Wrapper = styled.div`
    display: flex;
    padding-left: 50px;

    .item {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 10px;
        margin-right: 20px;
        text-align: center;
        min-width: 150px;
        position: relative;
        cursor: default;
    }

    .icon {
        position: absolute;
        top: 2px;
        left: 5px;
        color: lightblue;
    }

    .item > div > .sub-line {
        font-size: 12px;
    }
`;

interface IProps {
    centerId: number
}

interface IState {
    voucherDonorConsentFormMain: string,
    voucherDonorConsentFormAdditional: string,
    voucherHolderConsentForm: string
}

const VoucherProgram = (props: IProps) => {
    const [documents, setDocuments] = useState<IState>(null);

    useEffect(() => {
        axios.get(__API__ + '/file/documents').then(response => {
            setDocuments(response.data.results);
        });
    }, []);

    const handleSelect = (e: FormEvent<HTMLDivElement>) => {
        let url = '';

        if (e.currentTarget.id == 'enrollVoucherDonor') {
            url = `${__ADMIN__}/center/${props.centerId}/donor/add`
        } else {
            url = documents[e.currentTarget.id] + '?ts=' + moment().unix();
        }

        window.open(url, '_blank');
    };

    return (
        <>
            <SwapDonorsNav
                activeKey={'VOUCHER-PROGRAM'}
                centerId={props.centerId}
                donorId={0}
                recipientId={0}
                recipientAlias={''}
                recipientCenterId={0}
                recipientType={null}
                isAdminLogin={false}
                onTabChange={function (tab: string): void {
                    throw new Error('Function not implemented.');
                }} />

            <div className='container' style={{padding: 50}}>
                {/* <h3>Voucher Program</h3> */}

                <div style={{ marginBottom: 30 }}>The Voucher Program allows a donor to donate and provide vouchers for a patient in imminent need of a kidney transplant and/or multiple family members.</div>

                <Wrapper>
                    <div id='voucherDonorConsentFormMain' className='item btn btn-default' onClick={handleSelect}>
                        <div className='icon'>
                            <Icon icon={pencil} />
                        </div>
                        <div>
                            Voucher Donor
                            <br />
                            Consent Form
                            <br />
                            <span className='sub-line'>(Main - page 1)</span>
                        </div>
                    </div>

                    <div id='voucherDonorConsentFormAdditional' className='item btn btn-default' onClick={handleSelect}>
                        <div className='icon'>
                            <Icon icon={pencil} />
                        </div>
                        <div>
                            Voucher Donor
                            <br />
                            Consent Form
                            <br />
                            <span className='sub-line'>(Additional - page 2)</span>
                        </div>
                    </div>

                    <div id='voucherHolderConsentForm' className='item btn btn-default' onClick={handleSelect}>
                        <div className='icon'>
                            <Icon icon={pencil} />
                        </div>
                        <div>
                            Voucher Holder
                            <br />
                            Consent
                            <br />
                            Form
                        </div>
                    </div>

                    <div id='enrollVoucherDonor' className='item btn btn-default' onClick={handleSelect}>
                        <div className='icon'>
                            <Icon icon={profile} />
                        </div>
                        <div>
                            Enroll
                            <br />
                            Voucher
                            <br />
                            Donor
                        </div>
                    </div>
                </Wrapper>
            </div>
        </>
    );
}

export default VoucherProgram;
